import { Checkbox } from 'antd';
import get from 'lodash/get';
import React from 'react';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';


type PropType = {
    type: string;
    className?: string;
    name: string;
    label?: string;
    placeholder?: string;
    value?: any;
    withError?: boolean;
    disabled?: boolean;
    addorn?: any;
    setFieldValue: Function;
    setTouched: Function;
    onFocus: Function;
    onBlur: Function;
};

const RemainderDaysField = (props: PropType) => (
    <AppContext.Consumer>
        {({ theme, locale }) => (
            <InputWrapper
                theme={theme}
                className={`form-input-wrapper_${props.name} ${props.className || ''}`}
            ><br />
                <Checkbox>Enviar lembrete</Checkbox>
                <Input
                    theme={theme}
                    style={{ width: '6%', marginRight: '5px' }}
                    min={1} max={100000}
                    className={`form-input_${props.name} ${props.className || ''}`}
                    type={props.type}
                    name={props.name}
                    placeholder={I18n.l(props.placeholder || '')}
                    value={props.value}
                    disabled={props.disabled}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        props.setFieldValue(props.name, e.target.value);
                        props.setTouched({ [props.name]: true });
                    }}
                />@dias antes do prazo da auditoria
            </InputWrapper>
        )}
    </AppContext.Consumer>
);

const InputWrapper = styled.div`
    widht: 10%
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => get(theme, 'form.inputWrapper')};

  &.search {
    ${({ theme }) => get(theme, 'form.searchWrapper')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.authWrapper')};
  }
`;

const Input = styled.input`
  background: #fff;
  border-size: 15px;
  flex: 1;
  ${({ theme }) => get(theme, 'form.inputnumber')};

  &.search {
    ${({ theme }) => get(theme, 'form.search')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.auth')};
  }
`;



export default RemainderDaysField;
